module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qsPageBox"
  }, [_c('div', {
    staticClass: "qsPage"
  }, [_c('div', {
    staticClass: "userBox"
  }, [_c('el-descriptions', {
    attrs: {
      "column": 1
    }
  }, [_c('el-descriptions-item', {
    attrs: {
      "label": _vm.Language('客户姓名')
    }
  }, [_vm._v(_vm._s(_vm.uForm.cusName))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": _vm.Language('电话')
    }
  }, [_vm._v(_vm._s(_vm.uForm.tel))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "agentBox"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "80px",
      "size": "small"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.Language('外呼状态')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.Language('外呼状态')
    },
    model: {
      value: (_vm.tForm.status),
      callback: function($$v) {
        _vm.$set(_vm.tForm, "status", $$v)
      },
      expression: "tForm.status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.Language('未呼出'),
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.Language('呼叫成功'),
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.Language('呼叫失败'),
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.Language('外呼内容')
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.Language('外呼内容'),
      "type": "textarea",
      "rows": 4,
      "maxlength": "500"
    },
    model: {
      value: (_vm.tForm.content),
      callback: function($$v) {
        _vm.$set(_vm.tForm, "content", $$v)
      },
      expression: "tForm.content"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.Language('是否完成')
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.recordStatus),
      callback: function($$v) {
        _vm.recordStatus = $$v
      },
      expression: "recordStatus"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v(_vm._s(_vm.Language('是')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v(_vm._s(_vm.Language('否')))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.Language('完成说明')
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.Language('完成说明'),
      "type": "textarea",
      "rows": 4,
      "maxlength": "500"
    },
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium",
      "disabled": !_vm.lock
    },
    on: {
      "click": _vm.useApiSaveInfoFn
    }
  }, [_vm._v(_vm._s(_vm.Language('提交')))])], 1)], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-d7ae9e14","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/Questionnaire/defaultPage.vue
// module id = 1344
// module chunks = 5